import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AuthCallback() {
    const { googleSession } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const done = useRef(false);
    const [err, setErr] = useState("");

    useEffect(() => {
        if (done.current) return;
        done.current = true;
        const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
        if (!sessionId) { navigate("/login", { replace: true }); return; }
        (async () => {
            try {
                const u = await googleSession(sessionId);
                window.history.replaceState(null, "", window.location.pathname);
                navigate(u.role === "admin" ? "/admin" : "/account", { replace: true });
            } catch (e) {
                setErr(formatApiError(e.response?.data?.detail) || "Google sign-in failed");
            }
        })();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-brand-ink text-zinc-400" data-testid="auth-callback">
            {err ? (
                <>
                    <p className="text-sm text-red-400" data-testid="auth-callback-error">{err}</p>
                    <button onClick={() => navigate("/login", { replace: true })} className="text-sm text-brand-green underline">Back to log in</button>
                </>
            ) : (
                <><Loader2 className="animate-spin text-brand-green" /><p className="font-mono text-[11px] uppercase tracking-[0.3em]">Signing you in</p></>
            )}
        </div>
    );
}
